import { defineChain } from 'thirdweb/chains';
import { useAddress } from '@thirdweb-dev/react';
import { Chain } from '@thirdweb-dev/chains';
import { useWalletBalance as useThirdwebWalletBalance } from 'thirdweb/react';
import { Token } from '@app/types/token';
import { NATIVE_TOKEN_ADDRESS } from '@thirdweb-dev/sdk';
import { client } from '@app/constants/client';

export function useWalletBalance(
  network: Chain | null,
  token: Token | null,
  walletAddress?: string
) {
  const address = useAddress();

  return useThirdwebWalletBalance({
    chain: network ? defineChain(network) : undefined,
    address: walletAddress ?? address,
    client,
    tokenAddress:
      token?.contractAddress === NATIVE_TOKEN_ADDRESS
        ? ''
        : token?.contractAddress ?? ''
  });
}
